import React, {memo, useMemo} from 'react';
import {Tag} from 'antd';
import BukkuTooltip from '../../../Tooltip';
import styled from 'styled-components';

const Styled = styled.div`
  .fading-div {
    overflow: hidden;
    white-space: nowrap;
    mask-image: linear-gradient(to right, rgba(0,0,0,100%) 90%, rgba(0,0,0,0%));
  }
  
  /* 
  .fading-div {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    -ms-overflow-style: none;  // IE and Edge
    scrollbar-width: none;  // Firefox
  
    // Hide scrollbar for Chrome, Safari and Opera
    &::-webkit-scrollbar {
      display: none;
    }
  
    &.fade-right {
      mask-image: linear-gradient(to right, rgba(0,0,0,0.9) 90%, rgba(0,0,0,0));
    }
  
    &.fade-left {
      mask-image: linear-gradient(to left, rgba(0,0,0,0.9) 90%, rgba(0,0,0,0));
    }
  } 
  */
`;

function Tags(props) {
    const { list } = props;

    // const divRef = useRef(null);
    // const [showLeft, setShowLeft] = useState(false);
    // const [showRight, setShowRight] = useState(false);
    //
    // const resizeEvent = useSelector(state => state.App.resizeEvent);
    //
    // const handleScroll = div => {
    //     const position = div.getBoundingClientRect();
    //
    //     const scrollLength = (div.scrollWidth || 1) - (position.width || 0);
    //     if (scrollLength <= 0) {
    //         setShowLeft(false);
    //         setShowRight(false);
    //         return null;
    //     }
    //     const ratioScroll = (div.scrollLeft || 0) / scrollLength;
    //
    //     setShowLeft(ratioScroll > 0);
    //     setShowRight(ratioScroll < 1);
    //     return null;
    // };
    //
    // useEffect(() => {
    //     if (divRef.current)
    //         handleScroll(divRef.current);
    // }, []);
    //
    // useEffect(() => {
    //     if (divRef.current)
    //         handleScroll(divRef.current);
    // }, [resizeEvent]);

    const allTags = useMemo(() => {
        if (!list || !list.length)
            return "-";
        const tooltipDOM = (
            <ul>
                {
                    list.map(value => <li key={value}>{value}</li>)
                }
            </ul>
        );

        // const className = `fading-div ${showLeft ? 'fade-left' : ''} ${showRight ? 'fade-right' : ''}`;
        const className = 'fading-div';
        return (
            <BukkuTooltip
                title={tooltipDOM}
                // placement="topLeft"
            >
                <div className={className}>
                    {list.map(tag => <Tag key={tag}>{tag}</Tag>)}
                </div>
            </BukkuTooltip>
        );
    }, [list]);

    return (
        <Styled>
            {allTags}
        </Styled>
    );
}

export default memo(Tags);
